/* unplugin-vue-components disabled */import { ElTag as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import { ElForm as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElInput as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElSelect as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import "core-js/modules/es.array.reduce.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "flex justify-between"
};
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiUsdkGetVoucherList, apiUsdkUpdateVoucher } from '@/api/usdk';
import { useAppStore } from '@/store/modules/app';
import AddOrEditVoucher from './addOrEditVoucher.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'voucherManage',
  setup(__props) {
    const columns = [{
      label: '代金券名称',
      prop: 'name'
    }, {
      label: '满减金额',
      prop: 'benefit_prop',
      slot: 'benefit_prop'
    }, {
      label: '券面金额',
      prop: 'debenefit_propscr',
      slot: 'debenefit_propscr'
    }, {
      label: '发放张数',
      prop: 'benefit_size'
    }, {
      label: '已发放',
      prop: 'total',
      slot: 'total'
    }, {
      label: '未领取',
      prop: 'status1'
    }, {
      label: '待使用',
      prop: 'status2'
    }, {
      label: '已冻结',
      prop: 'status3'
    }, {
      label: '已使用',
      prop: 'status4'
    }, {
      label: '发放方式',
      prop: 'category',
      slot: 'category'
    }, {
      label: '状态',
      prop: 'status',
      slot: 'status'
    }, {
      label: '活动开始时间',
      prop: 'act_begin_at'
    }, {
      label: '活动结束时间',
      prop: 'act_end_at'
    }, {
      label: '操作',
      action: true
    }];
    const statusOption = {
      '-1': {
        text: '发放中',
        color: ''
      },
      0: {
        text: '未启用',
        color: 'info'
      },
      1: {
        text: '已启用',
        color: 'success'
      },
      2: {
        text: '已失效',
        color: 'danger'
      }
    };
    const addOrEditVoucherRef = ref();
    const filter = ref({
      category: undefined,
      name: ''
    });
    const options = ref([{
      label: '活动发放',
      value: '1'
    }, {
      label: '直接发放',
      value: '0'
    }]);
    const useApp = useAppStore();
    const gameInfo = computed(() => useApp.gameInfo);
    const getValue = computed(() => {
      return function (path, obj) {
        if (obj) {
          obj = JSON.parse(obj);
          path = path.split('.');
          return path.reduce((prev, next) => {
            return prev[next];
          }, obj);
        }
        return '';
      };
    });
    const getTableData = () => {
      tableLoading.value = true;
      apiUsdkGetVoucherList({
        game: gameInfo.value.Id,
        Page: current.value,
        PageSize: pageSize.value,
        ...filter.value
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
          total.value = res.pageTotal;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const handleClick = (type, data) => {
      if (type === 'update') {
        apiUsdkUpdateVoucher({
          actId: data.id,
          status: data.status == 0 ? 1 : 0
        }).then(res => {
          if (res.code === 0) {
            getTableData();
          }
        });
      } else if (type === 'del') {
        ElMessageBox.confirm(`删除后，已经发放的优惠券将从用户优惠券列表中消失，是否确认删除【不包含2】？`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiUsdkUpdateVoucher({
            actId: data.id,
            status: 3
          }).then(res => {
            if (res.code === 0) {
              getTableData();
            }
          });
        }).catch(() => {
          console.log('取消');
        });
      } else {
        addOrEditVoucherRef.value.show({
          type,
          data,
          gameInfo: gameInfo.value
        });
      }
    };
    const handleSuccess = () => {
      getTableData();
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      // handleSearch,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    watch(() => gameInfo.value, val => {
      if (val && val.Id) {
        getTableData();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_option = __unplugin_components_0;
      const _component_el_select = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_input = __unplugin_components_3;
      const _component_el_button = __unplugin_components_4;
      const _component_el_form = __unplugin_components_5;
      const _component_el_tag = __unplugin_components_6;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
        inline: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "发放方式"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(filter).category,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).category = $event),
            placeholder: "请选择发放方式"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "marginL20",
          label: "代金券名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(filter).name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(filter).name = $event),
            placeholder: "请输入代金券名称 "
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "marginL20",
            type: "primary",
            onClick: getTableData
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[2] || (_cache[2] = $event => handleClick('add'))
      }, {
        default: _withCtx(() => [_createTextVNode("添加代金券")]),
        _: 1
      })]), _createVNode(UTable, {
        options: columns,
        data: _unref(tableData),
        loading: _unref(tableLoading),
        pagination: "",
        "current-page": _unref(current),
        "page-size": _unref(pageSize),
        total: _unref(total),
        onSizeChange: _unref(handleSizeChange),
        onCurrentChange: _unref(handleCurrentChange)
      }, {
        benefit_prop: _withCtx(({
          scope
        }) => [_createTextVNode(_toDisplayString(_unref(getValue)('p.c.p', scope.row.benefit_prop)), 1)]),
        debenefit_propscr: _withCtx(({
          scope
        }) => [_createTextVNode(_toDisplayString(_unref(getValue)('p.e.p', scope.row.benefit_prop)), 1)]),
        total: _withCtx(({
          scope
        }) => [_createTextVNode(_toDisplayString(scope.row.status1 + scope.row.status2 + scope.row.status3 + scope.row.status4), 1)]),
        category: _withCtx(({
          scope
        }) => [_createTextVNode(_toDisplayString(scope.row.category == 0 ? '直接发放' : '活动发放'), 1)]),
        status: _withCtx(({
          scope
        }) => [_createVNode(_component_el_tag, {
          type: statusOption[scope.row.status].color
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(statusOption[scope.row.status].text), 1)]),
          _: 2
        }, 1032, ["type"])]),
        action: _withCtx(({
          scope
        }) => [scope.status == 0 || scope.status == 1 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: _normalizeClass([scope.status == 1 ? 'red' : '']),
          onClick: $event => handleClick('update', scope.row),
          link: "",
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.status == 0 ? '启用' : scope.row.status == 1 ? '暂停' : ''), 1)]),
          _: 2
        }, 1032, ["class", "onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleClick('edit', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("修改")]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          link: "",
          type: "danger",
          onClick: $event => handleClick('del', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("删除")]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 8, ["data", "loading", "current-page", "page-size", "total", "onSizeChange", "onCurrentChange"]), _createVNode(AddOrEditVoucher, {
        ref_key: "addOrEditVoucherRef",
        ref: addOrEditVoucherRef,
        onSuccess: handleSuccess
      }, null, 512)], 64);
    };
  }
});